import { Stack, Typography } from "@mui/material";
import { DefaultCard, PageLayout } from "components";
import DropLetter from "components/layout/dropLetter/DropLetter";
import React from "react";
import Address from "./Address";

function DonatePage() {
  return (
    <PageLayout>
      <DefaultCard title="DONATE">
        <Stack spacing={2}>
          <Typography variant="body2" lineHeight={1.8}>
            <DropLetter letter="H" />
            armony Hill is supported entirely by donations.
          </Typography>
          <Typography variant="body2" lineHeight={1.8}>
            You can donate through Venmo @Harmony-Hill-54, Zelle to
            jpccell81@live.com, or you can mail checks to the following address:
          </Typography>
          <Address indent color="#993300" />
          <Typography variant="body2">Thank you for your support!</Typography>
        </Stack>
      </DefaultCard>
    </PageLayout>
  );
}

export default DonatePage;
